<div class="nav-top mr-s">
  @if (!isAdmin) {
    <span class="idf-select dropdown-toggle" (click)="openIdfSelect()">
      IDF: {{ currentlyDisplayedIdf?.idf }}
    </span>
  }
  @if (isAdmin && canUse) {
    <input placeholder="IDF" (change)="setIdf($event.target.value)" class="input-idf">
  }
  @if (isAdmin && !canUse) {
    <input placeholder="IDF" class="input-idf" value="9999910" readonly>
  }
</div>